/**
 * Created by Thomas Mark
 * Date: 28.05.2019
 * Description: switch-Widget - Einfacher on/off-Schalter
 *
 * Das switch-Widget bietet die Möglichkeit einen Schalter darzustellen.
 * Der Schalter kann nur die Werte 0/1 darstellen (aus- bzw. eingeschaltet)
 *
 "fields": [
    {
        "id": "lights",
        "length": 1,
        "label": "Lights",
        "unitLabel": "",
        "description": "Switch lights on/off",
        "placeholder": "",
        "widget": "switch",
        "maxItems": 0,
        "visibleItems": 0,
        "group": null,
        "value": 0
        "enums": []
        "validation": null,
        "validationState": null,
        "validationMessage": null
    },
 *
 * Im number-Widget stehen folgende Widget-Attribute zur Verfügung:
 *
 * id            - Identifizierung des Feldes (muss eindeutig sein)
 * length        - Länge des Eingabefeldes bzw. Anzahl Zeichen (hier ohne Bedeutung)
 * label         - Bezeichnung, die links neben dem Widget erscheint
 * unitLabel    - Mengeneinheit, die rechts neben dem Widget erscheint
 * description   - Genauere Beschreibung des Feldes, wird bei klick auf das Fragezeichen angezeigt
 * placeholder   - Text der im Eingabefeld erscheint, solange noch kein Wert eingegeben wurde (hier ohne Bedeutung)
 * widget        - Bezeichnung des Widgets. Hier mit "switch" belegt
 * maxItems     - Maximale Anzahl an auswählbaren Werten/Zeichen (hier ohne Bedeutung)
 * visibleItems - Anzahl sichtbarer Werte in beiden Listen. Existieren mehr Werte, so erscheint ein vertikaler Scrollbalken
 * group         - Gruppenzuordnung (siehe dialog.group)
 * value         - Aktueller Wert (0=off, 1=on)
 * enums         - Alle Auswahlmöglichkeiten (hier ohne Bedeutung)
 * validation    - RegEx zur Validierung der Eingabe (hier ohne Bedeutung)
 * validationState   - Zustand der Validierung (hier ohne Bedeutung)
 * validationMessage - Fehlermeldung, falls Validierung erfolglos (hier ohne Bedeutung)
 *
 * Der Komponente können folgende Eigenschaften/Werte übergeben werden:
 * field - field-Object
 * value  - aktueller Wert
 * onChange - callback-Funktion. Wird aufgerufen, wenn sich der Wert im Feld verändert
 *
 */
import React from 'react';

const Switch = ({ field, value, onChange }) => {

    //console.log("Switch() field:", field);

    let className = (value) ? "bg-webasto-blue justify-end" : "justify-start";

    return (
        <div onClick={(e) => onChange(e, !value)} className="bg-gray-200 inline-block relative h-12 w-full">
            <span className={"absolute inset-y-0 right-0 border rounded-full border-grey flex items-center cursor-pointer mt-3 mr-2 w-16 h-8 " + className}>
                <span className="rounded-full border w-8 h-8 border-grey shadow-inner bg-white shadow">
                </span>
            </span>
        </div>
    )
};

export default Switch